export enum StaticValues {
  YES = 'yes',
  NO = 'no',
  OTHER_OPTION = '0',
  INSURANCE_TYPE_MEDICAL = 'Medical',
  INSURANCE_TYPE_VISION = 'Vision',
  INSURANCE_TYPE_OTHER = 'Other',
  FIELD_STATUS_HIDDEN = 'HIDDEN',
  FIELD_STATUS_OPTIONAL = 'OPTIONAL',
  FIELD_STATUS_MANDATORY = 'MANDATORY',
  INTERDEP_PHONENUMBER_EMAIL = 'INTERDEP_PHONENUMBER_EMAIL',
  ADD_NEW = 'Add new',
  RELATIONSHIP_SELF = 'Self',
}
